import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { IntegrationType } from "src/app/enums/IntegrationType.enum";
import { LabIntegrationDialogComponent } from "src/app/modals/lab-integration-dialog/lab-integration-dialog.component";
import { Lab } from "src/app/models/lab.model";
import { LabGroup } from "src/app/models/lab-group.model";
import { LabService } from "src/app/services/lab.service";
import { ToastService } from "src/app/services/toast.service";
import { RoutePaths } from "src/app/shared/constants/routePaths.constants";

import { trackById, trackByIndex } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-lab-integrations",
    templateUrl: "./lab-integrations.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        "./lab-integrations.component.scss",
        "./../../shared/grid/core-grid/core-grid.component.scss",
    ],
})
export class LabIntegrationsComponent implements OnInit {
    private static readonly knownColumns: { title: string; type: IntegrationType }[] = [
        { title: "Galson Labs", type: IntegrationType.GalsonLab },
        { title: "LIMS Labs", type: IntegrationType.Lims },
        { title: "ALS Labs", type: IntegrationType.AlsLab },
    ];

    tabs = [
        {
            routerLink: RoutePaths.labIntegrations,
            title: "Lab Integrations",
        },
        {
            routerLink: RoutePaths.labIntegrations,
            title: "HRIS",
        },
    ];
    labsList: Lab[] = [];
    labGroups: LabGroup[] = [];
    private searchTerm = "";

    constructor(
        private labService: LabService,
        protected dialog: MatDialog,
        private router: Router,
        private toastService: ToastService,
    ) {}

    ngOnInit(): void {
        this.loadLabs();
    }

    private loadLabs(): void {
        this.labService.get("", "id", "asc", 0, 10000, "").subscribe({
            next: (data: { data: Lab[] }) => {
                this.labsList = data.data ?? [];
                this.buildGroups();
            },
            error: (error) => {
                this.toastService.showError(error);
            },
        });
    }

    applyFilter(filterValue: string): void {
        this.searchTerm = filterValue.trim().toLowerCase();
        this.buildGroups();
    }

    private buildGroups(): void {
        const filtered = this.searchTerm
            ? this.labsList.filter((lab) =>
                  (lab.labName ?? "").toLowerCase().includes(this.searchTerm),
              )
            : this.labsList;

        const knownTypes = LabIntegrationsComponent.knownColumns.map(
            (column) => column.type,
        );

        const groups: LabGroup[] = LabIntegrationsComponent.knownColumns.map(
            (column) => ({
                title: column.title,
                labs: filtered.filter(
                    (lab) => lab.labIntegrationType === column.type,
                ),
            }),
        );

        const otherLabs = filtered.filter(
            (lab) => !knownTypes.includes(lab.labIntegrationType),
        );
        if (otherLabs.length) {
            groups.push({ title: "Other Labs", labs: otherLabs });
        }

        this.labGroups = groups;
    }

    openLabIntegrationDetails(item: Lab) {
        this.router.navigate([
            `/dashboard/integrations/lab-integrations/${item.id}`,
        ]);
    }

    openLab(entityId?: string) {
        const dialogRef = this.dialog.open(LabIntegrationDialogComponent, {
            data: {
                id: entityId ?? '',
            },
            width: "760px",
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe(() => this.loadLabs());
    }

    public trackById = trackById;
    public trackByIndex = trackByIndex;
}
